import { Box, Button, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import RowContainer from "../common/RowContainer";
import { useState } from "react";
import NavigationLink from "./NavigationLink";
import { Typography } from "@mui/material";
import logo from "../../assets/Vector-4.png";
import { FormattedMessage } from "react-intl";

const WebFooter = () => {
  const theme = useTheme();
  const list = [
    {
      link: "/legal",
      name: <FormattedMessage id="footer.legalNotes" />,
    },
    {
      link: "/privacy-policu",
      name: <FormattedMessage id="footer.privacyPolicy" />,
    },
    {
      link: "/cookie-policy",
      name: <FormattedMessage id="footer.cookiePolicy" />,
    },
  ];

  return (
    <footer>
      <RowContainer align="center">
        <Box
          display={"flex"}
          // component={Link}
          to="/"
          title="Revenge"
          width={{ xs: 200, md: 300 }}
        >
          <Typography
            color={theme.palette.text.primary}
            variant="p"
            fontSize={12}
          >
            &copy; Powered by Revenge Team
          </Typography>
        </Box>
        <nav>
          <RowContainer style={{ gap: "2rem" }} align="center">
            {list.map((item, index) => {
              return (
                <RowContainer marginleft={4} key={index}>
                  <NavigationLink to={item.link} index={index}>
                    <Typography
                      color={theme.palette.text.primary}
                      variant="h3"
                      fontSize="12px"
                      sx={{ "&:hover": { color: theme.palette.primary.main } }}
                    >
                      {item.name}
                    </Typography>
                  </NavigationLink>
                </RowContainer>
              );
            })}
          </RowContainer>
        </nav>
        <Box
          sx={{ display: { xs: "block", md: "none" } }}
          alignItems={"center"}
        ></Box>
      </RowContainer>
    </footer>
  );
};
export default WebFooter;
